import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as display from '../../../../../../../../display'
import { Store } from '../../../store'

/**
 * Body of modal used to edit org chart nodes
 */
@ngCore.Component({
  imports: [
    ds.input.text.Component,
    ds.input.textArea.Component,
    ds.input.select.single.Component,
    ds.ellipsisTooltip.Directive,
    display.value.Component,
    ngCommon.DatePipe,
  ],
  selector: 'atn-summit-org-chart-node-panel-project-engagements-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  private readonly _store = ngCore.inject(Store)

  /** TODO */
  public readonly projectEngagementsSg = ngCore.computed(
    (chartId = this._store.chartIdSg()) =>
      chartId &&
      this._store.treeEditorFeature.selectors
        .getProjectEngagements({ chartId })
        .asSignal()
        .map(item => ({
          ...item,
          period: ents.core.common.value.Raw.cast(
            item.period,
            ents.core.common.value.types.Intrinsic.DateRange,
          ),
        })),
  )
}
